import { Injectable } from "@angular/core";
import { ApiHttpService } from "./api-http.service";
import { Observable } from "rxjs";
import { SavedRequest } from "./request.service";

@Injectable()
export class RequestCommentsService {
  constructor(private apiHttp: ApiHttpService) {}

  public getAll = (requestId: number): Observable<RequestComment[]> => {
    return this.apiHttp.get<RequestComment[]>(`requests/${requestId}/comments`);
  };

  public save = (comment: RequestCommentSubmission): Observable<SavedRequest> => {
    return this.apiHttp.post<SavedRequest>(`requests/${comment.requestId}/comments`, comment);
  };
}

export interface RequestComment {
  comment: string;
  createdOn: Date;
  createdBy: number;
  source: string;
}

export interface RequestCommentSubmission {
    requestId: number;
    comment: string;
    source: string;
}

export var Sources = {
    rejectionFromSubmitted: "Rejected: Submitted to Draft",
    rejectionFromAssigned: "Rejected: Assigned to Draft",
    rejectionFromPlannedToDraft: "Rejected: Ready for Review to Draft",
    rejectionFromPlannedToPlanning: "Rejected: Ready for Review to Planning",
    submittedToAssigned: "Submitted to Assigned",
    AssignedToReadyForReview: "Assigned to Ready for Review",
    ReadyForReviewToReviewed: "Ready for Review to Reviewed"
};


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/services/request-comments.service.ts